<!--<h4>Calendar</h4>-->
<p>
    The Drop/Add widget displays information on upcoming or in-progress enrollment rounds. UNC Kenan-Flagler drop/add takes place in the <a href="/catalog">MyKE Course Catalog </a> pages for all MBA and MAC programs
</p>
